/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */
export enum RequestType {
  VS = 'vs',
  VScode = 'vscode'
}

export const EmptyGuid = "00000000-0000-0000-0000-000000000000";

export const isInIframe = (requestType?: RequestType) => {
  try {
    if (requestType) {
      if (requestType === RequestType.VScode) {
        return window?.parent?.frames['active-frame'] !== undefined;
      }
    }

    // condition for AppStudio iframe window (using it by default)
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export const isInTeams = (): boolean => {
  if ((window.parent === window.self && (window as any).nativeInterface) ||
    window.name === "embedded-page-container" ||
    window.name === "extension-tab-frame") {
    return true;
  }
  
  return false;
}

export const isInWebView = (requestType: RequestType): Boolean | null => {
  const query: string = window.location.search.substring(1);

  const vars: string[] = query.split('&');
  for (const varPairs of vars) {
    const pair: string[] = varPairs.split('=');
    if (decodeURIComponent(pair[0]) === 'platform') {

      return decodeURIComponent(pair[1]) === requestType;
    }
  }

  return null;
}

export const getOptionsFromWebView = () => {
  let options = [];

  let environments = JSON.parse(window.blobData!);
  let i = 0;
  for (var environment in environments)
    options.push({
      label:
        environments[environment].teamsAppId != ''
          ? environments[environment].name +
          " (" +
          environments[environment].teamsAppId +
          ")"
          : environments[environment].name,
      value:
       environments[environment].configuration,
      teamsAppId: environments[environment].teamsAppId,
      index: i++
    });

  return options;
};